import { render, staticRenderFns } from "./Aside2.vue?vue&type=template&id=32e66d8d&"
import script from "./Aside2.vue?vue&type=script&lang=js&"
export * from "./Aside2.vue?vue&type=script&lang=js&"
import style0 from "./Aside2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports